<div class="toast-container">

  @for (toast of toasts(); track toast.id) {

    <div
      class="pr-toast"
      [class.pr-toast-success]="toast.type === 'success'"
      [class.pr-toast-error]="toast.type === 'error'"
      [class.pr-toast-warning]="toast.type === 'warning'"
      [class.pr-toast-info]="toast.type === 'info'"
    >

        <div class="toast-icon">
        <i class="bi {{ icon(toast.type) }}"></i>
        </div>

      <div class="toast-content">

        @if (toast.title) {
          <strong>
            {{ toast.title }}
          </strong>
        }

        <span>
          {{ toast.message }}
        </span>

      </div>

      <button
        type="button"
        class="toast-close"
        aria-label="Cerrar notificación"
        (click)="close(toast.id)"
      >
        <i class="bi bi-x"></i>
      </button>

    </div>

  }

</div>